<template>
  <v-chip
    outlined
    class="ma-2"
    v-if="filter.formato.length !== 0"
    close
    small
    color="warning"
    text-color="primary"
    @click:close="() => clrFormat()"
  >
    {{ filter.formato.length !== 0 ? filterconsolidado.length : null }}
  </v-chip>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from "vuex";

  export default {
    methods: {
      ...mapMutations(["CLR_BUSCARFORMATO", "setMenuDomoDeco"]),
      clrFormat() {
        this.CLR_BUSCARFORMATO();
        this.setMenuDomoDeco(false)
      },
    },
    computed: {
      ...mapGetters(["filterconsolidado"]),
      ...mapState(["filter"]),
    },
  };
</script>
